import { useTranslation } from 'react-i18next'

import { formatAmount, formatDate, getDisbursedByLabel, getPaymentStatusBadge } from '../../utils/utils'
import styles from '../CandidateDetailsContainer.module.scss'

import { Badge, CardContent, CardDashboard, Flex, IllustratedMessage } from '@percent/lemonade'
import type { CandidatePaymentDetailsProps } from './CandidatePaymentDetails.types'

export function CandidatePaymentDetails({ paymentDetails, award }: Readonly<CandidatePaymentDetailsProps>) {
  const { t, i18n } = useTranslation()

  const isPaymentDetailsNotAvailable = !paymentDetails?.status

  const { label, variant } = getPaymentStatusBadge(paymentDetails?.status, t)

  return (
    <Flex direction="column" data-testid="candidate-payment-details" className={styles.cardCtn}>
      {isPaymentDetailsNotAvailable ? (
        <CardDashboard data-testid="no-payment-details-content">
          <IllustratedMessage
            title={t('grants.paymentDetails.noPaymentDetails.title')}
            description={t('grants.paymentDetails.noPaymentDetails.description')}
            illustration="no-payouts"
          />
        </CardDashboard>
      ) : (
        <CardDashboard title={t('grants.paymentDetails.title')} data-testid="payment-details-card">
          <CardContent title={t('grants.paymentDetails.awardAmount')} testId="payment-amount-usd">
            {formatAmount({
              amount: award?.amount,
              currency: award?.currency,
              locale: i18n.language,
              t
            })}
          </CardContent>
          <CardContent title={t('grants.paymentDetails.amountPaid')} testId="payment-amount-local">
            {formatAmount({
              amount: paymentDetails?.payment?.amount,
              currency: paymentDetails?.payment?.currency,
              locale: i18n.language,
              t
            })}
          </CardContent>
          <CardContent title={t('grants.paymentDetails.paymentStatus')} testId="payment-status">
            <Badge variant={variant}>{label}</Badge>
          </CardContent>
          <CardContent title={t('grants.paymentDetails.paymentDate')} testId="payment-date">
            {paymentDetails?.paidAt ? formatDate(paymentDetails.paidAt) : t('typography.notAvailable')}
          </CardContent>
          <CardContent title={t('grants.paymentDetails.disbursedBy')} testId="payment-disbursed-by">
            {getDisbursedByLabel(paymentDetails?.disbursedBy, t)}
          </CardContent>
        </CardDashboard>
      )}
    </Flex>
  )
}
